import { useEffect, type ReactNode } from 'react'
import { ChevronLeft } from 'lucide-react'

/** Full-screen on a phone, centred panel on a wide screen. Back chevron, centred title. */
export function Sheet({ title, onClose, children, action }: {
  title: string
  onClose: () => void
  children: ReactNode
  action?: ReactNode
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = '' }
  }, [onClose])

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet full" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={title}>
        <header className="sheet-head">
          <button className="icon-btn" onClick={onClose} aria-label="Back">
            <ChevronLeft size={22} strokeWidth={2.6} />
          </button>
          <h2>{title}</h2>
          {action ?? <span style={{ width: 38 }} />}
        </header>
        <div className="sheet-body noscroll">{children}</div>
      </div>
    </div>
  )
}
